import React from 'react';
import PropTypes from 'prop-types';

const ThickDisabled = ({ color = '#D8D8D8' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/thick-disable-default"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Group">
                <rect
                    id="Rectangle"
                    fill={color}
                    fillRule="nonzero"
                    opacity="0"
                    x="0"
                    y="0"
                    width="18"
                    height="18"
                />
                <polygon id="Line" fill="#B5BDC5" points="6 10 6 8 12 8 12 10" />
            </g>
        </g>
    </svg>
);

ThickDisabled.propTypes = {
    color: PropTypes.string,
};

export default ThickDisabled;
